/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import './global-react.tsx';
import './inject-why-did-you-render.tsx';
import './inject-dev-stability-render.tsx';
import './hydration-support.tsx';
